export default __webpack_public_path__ + "static/media/free-snacks.e556c11a.svg";